(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dr-article-body"] && !Shopify.designMode) return;
  try {
    
/* Auto-generate TOC from H2s inside the body, scoped to this article only. */
(function() {
  var bodyEl = document.querySelector('[data-dr-article-body]');
  var tocList = document.querySelector('[data-dr-article-toc-list]');
  if (!bodyEl || !tocList) return;

  var h2s = bodyEl.querySelectorAll('h2');
  if (h2s.length < 2) {
    // not enough H2s to bother — hide the TOC
    var tocEl = document.querySelector('[data-dr-article-toc]');
    if (tocEl) tocEl.style.display = 'none';
    return;
  }

  function slugify(text) {
    return String(text).toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  Array.prototype.forEach.call(h2s, function(h2, i) {
    var id = h2.id || 'h2-' + slugify(h2.textContent || '') || ('section-' + i);
    h2.id = id;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = h2.textContent;
    li.appendChild(a);
    tocList.appendChild(li);
  });

  /* Highlight active TOC link as user scrolls — IntersectionObserver based. */
  var links = tocList.querySelectorAll('a');
  var byId = {};
  Array.prototype.forEach.call(links, function(a) { byId[a.getAttribute('href').slice(1)] = a; });
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      var a = byId[e.target.id];
      if (a && e.isIntersecting) {
        Array.prototype.forEach.call(links, function(l) { l.removeAttribute('data-active'); });
        a.setAttribute('data-active', 'true');
      }
    });
  }, { rootMargin: '-30% 0px -55% 0px' });
  Array.prototype.forEach.call(h2s, function(h2) { obs.observe(h2); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-blog-archive"] && !Shopify.designMode) return;
  try {
    
/* Load-more AJAX appender — uses Shopify's Section Rendering API. */
(function() {
  function init() {
    var grid = document.querySelector('[data-dr-archive-grid]');
    var btn  = document.querySelector('[data-dr-archive-load-more]');
    var countEl = document.querySelector('[data-dr-archive-count]');
    if (!grid || !btn) return;

    var nextUrl = grid.getAttribute('data-next-page');
    if (!nextUrl) { btn.style.display = 'none'; return; }

    btn.addEventListener('click', function() {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.setAttribute('data-loading', 'true');

      /* Fetch the next paginated page as a full HTML document and lift out
         only the new cards. We tried Shopify's Section Rendering API
         (?sections=<id>) but it returns null for paginated sections — a
         known platform limitation. A full-page fetch is heavier but works
         reliably and benefits from edge caching of the regular page URL. */
      fetch(nextUrl, { headers: { 'Accept': 'text/html' } })
        .then(function(r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function(html) {
          /* Parse the returned full-page HTML and lift out new cards + next-page URL. */
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('.dr-blog-archive__card');
          if (newCards.length === 0) throw new Error('no cards in next page');

          newCards.forEach(function(card) {
            card.classList.add('dr-blog-archive__card--fade-in');
            grid.appendChild(card);
          });

          /* Pull the next paginated URL from the response's grid (it's the
             same data attribute we read on first paint). If absent, we're at
             the last page — hide the button and show end-state. */
          var newGrid = doc.querySelector('[data-dr-archive-grid]');
          var newNext = newGrid ? newGrid.getAttribute('data-next-page') : null;

          if (newNext) {
            grid.setAttribute('data-next-page', newNext);
            nextUrl = newNext;
          } else {
            grid.removeAttribute('data-next-page');
            btn.style.display = 'none';
            var moreBlock = btn.parentElement;
            if (moreBlock) {
              moreBlock.classList.add('dr-blog-archive__more--done');
              var p = document.createElement('p');
              p.className = 'dr-blog-archive__count';
              var total = grid.querySelectorAll('.dr-blog-archive__card').length;
              p.textContent = 'All ' + total + ' articles shown.';
              if (countEl && countEl.parentElement) countEl.parentElement.replaceWith(p);
            }
          }

          /* Update visible count if we still have a button. */
          if (countEl) {
            var shown = grid.querySelectorAll('.dr-blog-archive__card').length;
            countEl.textContent = String(shown);
          }
        })
        .catch(function(err) {
          /* On error, fall back to a hard navigation so the user can still
             reach the next page rather than getting stuck. */
          console.warn('dr-blog-archive: load-more failed, falling back to navigation', err);
          window.location.href = nextUrl;
        })
        .finally(function() {
          btn.disabled = false;
          btn.removeAttribute('data-loading');
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-blog"] && !Shopify.designMode) return;
  try {
    
/* Home-page blog row slider — prev/next buttons + progress fill.
   Replaces the older inline <script> that used
   document.currentScript.previousElementSibling (fragile when Shopify
   shifts the script position during section rendering). This version
   queries .dr-blog instances directly, supports multiple instances on
   one page, and re-inits on Shopify theme-editor section reloads. */
(function() {
  function initOne(section) {
    var track    = section.querySelector('.dr-blog__cards');
    var slider   = section.querySelector('.dr-blog__slider');   /* whole controls block (progress + arrows) */
    var fillEl   = section.querySelector('.dr-blog__progress-fill');
    var prevBtn  = section.querySelector('.dr-blog__arrow--prev');
    var nextBtn  = section.querySelector('.dr-blog__arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    function cards() { return Array.prototype.slice.call(track.querySelectorAll('.dr-blog__card')); }
    function cardStep() {
      var list = cards();
      if (list.length < 2) return track.clientWidth;
      var first = list[0].getBoundingClientRect();
      var second = list[1].getBoundingClientRect();
      var step = second.left - first.left;
      return step > 0 ? step : track.clientWidth;
    }
    function updateState() {
      var max = track.scrollWidth - track.clientWidth;
      var noOverflow = max <= 1;
      /* If nothing to scroll, hide the whole controls block — disabled-looking
         buttons read as broken; invisible reads as "nothing more here". */
      if (slider) slider.style.display = noOverflow ? 'none' : '';
      var pct = noOverflow ? 100 : Math.min(100, Math.max(0, (track.scrollLeft / max) * 100));
      if (fillEl) fillEl.style.width = pct + '%';
      prevBtn.disabled = noOverflow || track.scrollLeft <= 1;
      nextBtn.disabled = noOverflow || track.scrollLeft >= max - 1;
    }
    prevBtn.addEventListener('click', function() {
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function() {
      track.scrollBy({ left:  cardStep(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState);
    /* Initial state + a second pass after layout settles. */
    updateState();
    setTimeout(updateState, 50);
  }

  function initAll() {
    var sections = document.querySelectorAll('.dr-blog');
    Array.prototype.forEach.call(sections, initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme-editor re-init when the section reloads. */
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector('.dr-blog')) initAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-pdp-bundle-upsell"] && !Shopify.designMode) return;
  try {
    
/* ---------- Lazy-fetch recommendations ----------
   Shopify ships `recommendations` as a Liquid object that's only populated
   when the section is requested via the /recommendations/products endpoint.
   This web component triggers that request on mount, parses the returned
   HTML, and swaps the section's body into place — without ever leaving the
   declarative Liquid template. */
if (!customElements.get('bundle-recommendations')) {
  class BundleRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return; // manual mode — nothing to fetch
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fresh = doc.querySelector('bundle-recommendations');
          if (fresh && fresh.innerHTML.trim()) {
            this.innerHTML = fresh.innerHTML;
            this.classList.add('is-loaded');
            // Re-bind the bundle CTA's click handler on the swapped-in button
            bindBundleCta(this);
          }
        })
        .catch((e) => console.warn('[dr-pdp-bundle] recommendations fetch failed', e));
    }
  }
  customElements.define('bundle-recommendations', BundleRecommendations);
}

function bindBundleCta(scope) {
  const btn = scope.querySelector('.dr-pdp-bundle__cta');
  if (!btn || btn.dataset.bound) return;
  btn.dataset.bound = '1';
  btn.addEventListener('click', async () => {
    const ids = (btn.dataset.bundleVariants || '').split(',').map((s) => s.trim()).filter(Boolean);
    if (!ids.length) { window.location.href = '/cart'; return; }
    btn.disabled = true;
    const original = btn.innerHTML;
    btn.innerHTML = '<span>Adding...</span>';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id: parseInt(id, 10), quantity: 1 })) })
      });
      window.location.href = '/cart';
    } catch (e) {
      btn.disabled = false;
      btn.innerHTML = original;
      console.error('Bundle add failed:', e);
    }
  });
}

// Bind any CTA already present on first paint (manual mode / cached recommendations)
document.querySelectorAll('.dr-pdp-bundle').forEach((s) => bindBundleCta(s));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Hoist every PDP hero instance on the page (rare but possible if previewing).
  document.querySelectorAll('.dr-pdp-hero').forEach(initHero);

  function initHero(root) {
    initGallery(root);
    initPlanRadios(root);
    initFrequencyPills(root);
    initQtyStepper(root);
    initVariantPicker(root);
  }

  /* ---------------- Gallery ---------------- */
  function initGallery(root) {
    const slides = root.querySelectorAll('[data-slide-index]');
    const thumbs = root.querySelectorAll('[data-thumb-index]');
    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    const counter = root.querySelector('[data-gallery-current]');
    const total = slides.length;
    if (total <= 1) return;

    let current = 0;
    const go = (idx) => {
      const newIdx = (idx + total) % total;
      slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === newIdx);
        s.setAttribute('aria-hidden', i === newIdx ? 'false' : 'true');
      });
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === newIdx);
        t.setAttribute('aria-selected', i === newIdx ? 'true' : 'false');
      });
      if (counter) counter.textContent = newIdx + 1;
      current = newIdx;
    };

    prev && prev.addEventListener('click', () => go(current - 1));
    next && next.addEventListener('click', () => go(current + 1));
    thumbs.forEach((t) => {
      t.addEventListener('click', () => go(parseInt(t.dataset.thumbIndex, 10)));
    });
  }

  /* ---------------- Selling-plan radios ---------------- */
  function initPlanRadios(root) {
    const plans = root.querySelectorAll('.dr-pdp-hero__plan');
    plans.forEach((plan) => {
      const input = plan.querySelector('.dr-pdp-hero__plan-input');
      if (!input || input.disabled) return;
      plan.addEventListener('click', (e) => {
        if (e.target.tagName === 'SELECT') return; // let dropdown work
        input.checked = true;
        plans.forEach((p) => p.classList.toggle('is-selected', p === plan));
      });
    });
  }

  /* ---------------- Frequency PILLS (replaces the old <select>) ----------
     Each pill is a <button> with data-plan-pill + data-plan-id. Clicking:
       1) updates aria-pressed + is-selected on the pill set (mutually exclusive)
       2) updates the parent subscribe radio's value to the chosen plan ID
       3) selects the subscribe radio (so the form submits the subscription)
     Falls through cleanly in stub mode (no subscribe radio with the type attr) -
     the visual still toggles, but the form submits the one-time selection. */
  function initFrequencyPills(root) {
    const pills = root.querySelectorAll('[data-plan-pill]');
    if (!pills.length) return;
    const subscribeInput = root.querySelector('[data-plan-type="subscribe"]');

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        pills.forEach((p) => {
          const on = (p === pill);
          p.classList.toggle('is-selected', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (subscribeInput) {
          subscribeInput.value = pill.getAttribute('data-plan-id') || subscribeInput.value;
          subscribeInput.checked = true;
          /* Keep the parent .dr-pdp-hero__plan card visually selected */
          root.querySelectorAll('.dr-pdp-hero__plan').forEach((p) => {
            p.classList.toggle('is-selected', p.contains(subscribeInput));
          });
        }
      });
    });
  }

  /* ---------------- Quantity stepper ---------------- */
  function initQtyStepper(root) {
    const input = root.querySelector('[data-qty-input]');
    const dec = root.querySelector('[data-qty-dec]');
    const inc = root.querySelector('[data-qty-inc]');
    if (!input) return;
    dec && dec.addEventListener('click', () => {
      const v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    inc && inc.addEventListener('click', () => {
      const v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
    });
  }

  /* ---------------- Variant picker ---------------- */
  function initVariantPicker(root) {
    const groups = root.querySelectorAll('.dr-pdp-hero__variant-group');
    const variantInput = root.querySelector('[data-variant-id-input]');
    const variantJsonEl = root.querySelector('[data-variant-json]');
    if (!groups.length || !variantInput || !variantJsonEl) return;
    const variants = JSON.parse(variantJsonEl.textContent || '[]');

    function selectedOptions() {
      const opts = [];
      groups.forEach((g) => {
        const checked = g.querySelector('input[data-variant-option]:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function matchVariant() {
      const selected = selectedOptions();
      return variants.find((v) =>
        v.options.every((opt, i) => opt === selected[i])
      );
    }

    function update() {
      const variant = matchVariant();
      if (!variant) return;
      variantInput.value = variant.id;
      // Update visual selection
      groups.forEach((g) => {
        g.querySelectorAll('.dr-pdp-hero__variant-pill').forEach((pill) => {
          const radio = pill.querySelector('input');
          pill.classList.toggle('is-selected', radio.checked);
        });
      });
      // Update ATC label availability
      const atcLabel = root.querySelector('[data-atc-label]');
      const atcBtn = root.querySelector('.dr-pdp-hero__atc');
      if (atcLabel && atcBtn) {
        if (variant.available) {
          atcBtn.removeAttribute('disabled');
          atcBtn.removeAttribute('aria-disabled');
          atcLabel.textContent = atcBtn.dataset.atcText || atcLabel.textContent;
        } else {
          atcBtn.setAttribute('disabled', '');
          atcBtn.setAttribute('aria-disabled', 'true');
          atcLabel.textContent = atcBtn.dataset.soldOutText || 'Sold out';
        }
      }
      // Update browser URL with ?variant=
      try {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (_) {}
    }

    groups.forEach((g) => {
      g.querySelectorAll('input[data-variant-option]').forEach((radio) => {
        radio.addEventListener('change', update);
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-pdp-sticky-mobile"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sticky = document.querySelector('.dr-pdp-sticky');
  if (!sticky) return;
  const hero = document.querySelector('.dr-pdp-hero');
  if (!hero) {
    sticky.hidden = false;
    sticky.classList.add('is-active');
    return;
  }
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // Show sticky bar once the hero is OUT of view (scrolled past)
      if (entry.intersectionRatio < 0.1) {
        sticky.hidden = false;
        sticky.classList.add('is-active');
      } else {
        sticky.classList.remove('is-active');
      }
    });
  }, { threshold: [0, 0.1, 0.5] });
  obs.observe(hero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-pdp-video-proof"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.dr-pdp-video-proof').forEach((root) => {
  const media = root.querySelector('.dr-pdp-video-proof__media');
  const btn = root.querySelector('[data-play-btn]');
  const embedUrl = media && media.dataset.embedUrl;
  if (!btn) return;
  if (!embedUrl) {
    // Render the play button but disable the click handler — admin still
    // sees the design; once they paste a real URL in the editor, the click
    // wiring activates without code changes.
    btn.addEventListener('click', (e) => e.preventDefault());
    return;
  }
  btn.addEventListener('click', () => {
    const iframe = document.createElement('iframe');
    iframe.src = embedUrl;
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', root.querySelector('.dr-pdp-video-proof__heading')?.textContent || 'Video');
    media.innerHTML = '';
    media.appendChild(iframe);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-popup-signup"] && !Shopify.designMode) return;
  try {
    
/* Dr. Schrock's signup popup — hybrid trigger + Klaviyo subscribe */
class DrSignupPopup extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    this.cfg = {
      desktopDelay:    parseInt(this.dataset.desktopDelay,    10) || 8000,
      mobileDelay:     parseInt(this.dataset.mobileDelay,     10) || 15000,
      mobileScrollPct: parseInt(this.dataset.mobileScrollPct, 10) || 50,
      dismissDays:     parseInt(this.dataset.dismissDays,     10) || 30,
      signupDays:      parseInt(this.dataset.signupDays,      10) || 365,
      couponCode:      this.dataset.couponCode || 'DRSCHROCK10',
      klaviyoCompany:  this.dataset.klaviyoCompany || '',
      klaviyoList:     this.dataset.klaviyoList || ''
    };

    if (this.shouldSuppress()) { this.remove(); return; }

    this.bind();
    this.armTriggers();
  }

  /* ─────────────── Suppression rules ─────────────── */
  shouldSuppress() {
    const path = window.location.pathname.toLowerCase().replace(/\/$/, '');
    /* Suppress on checkout flow */
    if (path.startsWith('/cart') || path.startsWith('/checkout')) return true;
    /* Suppress on any gift-card surface — visitor is shopping for someone else,
       welcome-offer is irrelevant + interrupts gifting flow */
    if (path === '/pages/gifts' || path === '/pages/redeem-gift-card') return true;
    if (path === '/collections/gift-cards') return true;
    if (path.startsWith('/products/') && path.includes('gift-card')) return true;
    /* Suppression cookies */
    if (this.getCookie('drs_popup_signed_up') === '1') return true;
    if (this.getCookie('drs_popup_dismissed') === '1') return true;
    if (sessionStorage.getItem('drs_popup_shown_this_session') === '1') return true;
    return false;
  }

  /* ─────────────── Trigger arming ─────────────── */
  armTriggers() {
    const isMobile = window.matchMedia('(max-width: 700px)').matches;
    let fired = false;
    const open = () => {
      if (fired) return;
      fired = true;
      this.clearTriggers();
      this.open();
    };
    this.clearTriggers = () => {};

    if (isMobile) {
      /* Mobile: 15s OR 50% scroll */
      const timer = setTimeout(open, this.cfg.mobileDelay);
      const onScroll = () => {
        const pct = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
        if (pct >= this.cfg.mobileScrollPct) open();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      this.clearTriggers = () => {
        clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
      };
    } else {
      /* Desktop: exit-intent → 8s fallback */
      const timer = setTimeout(open, this.cfg.desktopDelay);
      const onMouseOut = (e) => {
        /* Only fire when the mouse leaves through the TOP of the viewport */
        if (!e.relatedTarget && e.clientY < 10) open();
      };
      document.addEventListener('mouseout', onMouseOut);
      this.clearTriggers = () => {
        clearTimeout(timer);
        document.removeEventListener('mouseout', onMouseOut);
      };
    }
  }

  /* ─────────────── Event bindings ─────────────── */
  bind() {
    this.querySelectorAll('[data-popup-close]').forEach(el => {
      el.addEventListener('click', () => this.dismiss());
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) this.dismiss();
    });
    const form = this.querySelector('[data-popup-form]');
    if (form) form.addEventListener('submit', (e) => this.handleSubmit(e));
    const copyBtn = this.querySelector('[data-popup-copy]');
    if (copyBtn) copyBtn.addEventListener('click', () => this.copyCode());
  }

  /* ─────────────── Open / dismiss ─────────────── */
  open() {
    this.removeAttribute('hidden');
    /* Force a reflow so the CSS transition runs */
    void this.offsetWidth;
    this.classList.add('is-open');
    sessionStorage.setItem('drs_popup_shown_this_session', '1');
    /* Lock body scroll */
    this._scrollTop = window.scrollY;
    document.body.style.overflow = 'hidden';
  }

  dismiss() {
    this.classList.remove('is-open');
    document.body.style.overflow = '';
    this.setCookie('drs_popup_dismissed', '1', this.cfg.dismissDays);
    setTimeout(() => { this.setAttribute('hidden', ''); }, 260);
  }

  /* ─────────────── Klaviyo subscribe ─────────────── */
  async handleSubmit(e) {
    e.preventDefault();
    const input = this.querySelector('[data-popup-form] input[type=email]');
    const submitBtn = this.querySelector('[data-popup-submit]');
    const errorEl = this.querySelector('[data-popup-error]');

    errorEl.hidden = true;
    const email = (input.value || '').trim();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      errorEl.hidden = false;
      input.focus();
      return;
    }

    submitBtn.classList.add('is-loading');
    submitBtn.disabled = true;

    try {
      await this.klaviyoSubscribe(email);
      this.showSuccess();
      this.setCookie('drs_popup_signed_up', '1', this.cfg.signupDays);
      this.setCookie('drs_popup_dismissed', '', -1); /* clear dismissed cookie */
    } catch (err) {
      console.error('[DrSignupPopup] Klaviyo subscribe failed:', err);
      errorEl.textContent = 'Something went wrong. Please try again.';
      errorEl.hidden = false;
      submitBtn.classList.remove('is-loading');
      submitBtn.disabled = false;
    }
  }

  async klaviyoSubscribe(email) {
    /* If no Klaviyo company/list configured, skip API call but still show success
       so the popup is usable. The admin should add the keys via theme settings. */
    if (!this.cfg.klaviyoCompany || !this.cfg.klaviyoList) {
      console.warn('[DrSignupPopup] Klaviyo company_id or list_id not set in theme settings — skipping API call.');
      return;
    }

    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.cfg.klaviyoCompany)}`;
    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Dr. Schrock\'s Popup',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: this.cfg.klaviyoList } }
        }
      }
    };
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(body)
    });
    if (!resp.ok && resp.status !== 202) {
      const text = await resp.text();
      throw new Error(`Klaviyo ${resp.status}: ${text}`);
    }
  }

  showSuccess() {
    this.querySelector('[data-state=form]').hidden = true;
    this.querySelector('[data-state=success]').hidden = false;
  }

  /* ─────────────── Copy code ─────────────── */
  async copyCode() {
    const codeEl = this.querySelector('[data-popup-coupon]');
    const code = codeEl ? codeEl.textContent.trim() : this.cfg.couponCode;
    const defaultLabel = this.querySelector('[data-copy-default]');
    const successLabel = this.querySelector('[data-copy-success]');
    try {
      await navigator.clipboard.writeText(code);
      defaultLabel.hidden = true;
      successLabel.hidden = false;
      setTimeout(() => {
        defaultLabel.hidden = false;
        successLabel.hidden = true;
      }, 1800);
    } catch (err) {
      console.warn('[DrSignupPopup] Clipboard write failed:', err);
    }
  }

  /* ─────────────── Cookie helpers ─────────────── */
  setCookie(name, value, days) {
    const expires = days > 0
      ? new Date(Date.now() + days * 864e5).toUTCString()
      : new Date(0).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  }
  getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
}
customElements.define('dr-signup-popup', DrSignupPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-testimonials"] && !Shopify.designMode) return;
  try {
    
/* Testimonials horizontal slider — prev/next buttons + progress fill.
   Robust pattern: iterates over every .dr-testi instance on the page so
   it survives section reorders, multiple placements, and (theoretically)
   multiple instances on one page. */
(function() {
  function initOne(section) {
    var track    = section.querySelector('.dr-testi__cards');
    var controls = section.querySelector('.dr-testi__controls');   /* whole controls block */
    var fillEl   = section.querySelector('.dr-testi__progress-fill');
    var prevBtn  = section.querySelector('.dr-testi__arrow--prev');
    var nextBtn  = section.querySelector('.dr-testi__arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    function cards() { return Array.prototype.slice.call(track.querySelectorAll('.dr-testi__card')); }
    function cardStep() {
      var list = cards();
      if (list.length < 2) return track.clientWidth;
      var first = list[0].getBoundingClientRect();
      var second = list[1].getBoundingClientRect();
      var step = second.left - first.left;
      return step > 0 ? step : track.clientWidth;
    }
    function updateState() {
      var max = track.scrollWidth - track.clientWidth;
      var noOverflow = max <= 1;
      /* Hide the whole progress+arrows block when there's nothing to scroll —
         disabled-looking buttons read as broken; invisible reads as clean. */
      if (controls) controls.style.display = noOverflow ? 'none' : '';
      var pct = noOverflow ? 100 : Math.min(100, Math.max(0, (track.scrollLeft / max) * 100));
      if (fillEl) fillEl.style.width = pct + '%';
      prevBtn.disabled = noOverflow || track.scrollLeft <= 1;
      nextBtn.disabled = noOverflow || track.scrollLeft >= max - 1;
    }
    prevBtn.addEventListener('click', function() {
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function() {
      track.scrollBy({ left:  cardStep(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState);
    /* Run once at startup AND after a tick in case images haven't laid out yet. */
    updateState();
    setTimeout(updateState, 50);
  }

  function initAll() {
    var sections = document.querySelectorAll('.dr-testi');
    Array.prototype.forEach.call(sections, initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init when Shopify's theme editor reloads this section. */
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector('.dr-testi')) initAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-track-order"] && !Shopify.designMode) return;
  try {
    
/* Track-order page interactions:
   - Read tracking number from input
   - On carrier-button click, open that carrier's tracking URL in a new tab
   - Show/hide clear button + error message as appropriate */
(function() {
  function initOne(section) {
    var input    = section.querySelector('[data-dr-track-input]');
    var clearBtn = section.querySelector('[data-dr-track-clear]');
    var errorEl  = section.querySelector('[data-dr-track-error]');
    var carriers = section.querySelectorAll('[data-dr-track-carrier]');
    if (!input || carriers.length === 0) return;

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || 'Enter your tracking number before choosing a carrier.';
      errorEl.hidden = false;
    }
    function hideError() { if (errorEl) errorEl.hidden = true; }
    function updateClearState() {
      if (clearBtn) clearBtn.hidden = !input.value;
    }

    input.addEventListener('input', function() {
      hideError();
      updateClearState();
    });
    input.addEventListener('keydown', function(e) {
      /* Pressing Enter on a non-empty value triggers the primary carrier */
      if (e.key === 'Enter' && input.value.trim()) {
        e.preventDefault();
        var primary = section.querySelector('.dr-track__carrier--primary');
        if (primary) primary.click();
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        input.value = '';
        updateClearState();
        hideError();
        input.focus();
      });
    }

    Array.prototype.forEach.call(carriers, function(btn) {
      btn.addEventListener('click', function() {
        var raw = (input.value || '').trim();
        if (!raw) {
          showError();
          input.focus();
          return;
        }
        var tpl = btn.getAttribute('data-track-url') || '';
        if (!tpl) return;
        var url = tpl.replace('{{TRK}}', encodeURIComponent(raw));
        window.open(url, '_blank', 'noopener,noreferrer');
      });
    });

    updateClearState();
  }

  function initAll() {
    var sections = document.querySelectorAll('.dr-track');
    Array.prototype.forEach.call(sections, initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector('.dr-track')) initAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
